export function validateJSON(raw) {
  try {
    const parsed = JSON.parse(raw || "{}");
    if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed)) {
      return { ok: false, error: "Must be a JSON object." };
    }
    return { ok: true, value: parsed };
  } catch (error) {
    return { ok: false, error: error.message || "Invalid JSON." };
  }
}
